import React from "react";
import { LargeProjectList, ProjectList, Personal } from "../../../data/ProjectData";
import MediumCard from "./../Release/MediumCard"
import { ReleasedList } from "../../../data/ReleaseData";

function Projects() {
  return (
    <>
      <div className="ProjectWrapper" id="illusionlabs">
        <div className="Container">
          <div className="SectionTitle">Illusion Labs</div>

          <MediumCard projects={ReleasedList} />
        </div>
      </div>

      {/* <div className="ProjectWrapper" id="projects">
        <div className="Container">
          <div className="SectionTitle">Projects</div>

          <MediumCard projects={Personal} />
        </div>
      </div> */}
    </>
  );
}

export default Projects;
